import {
  Box,
  Checkbox,
  ListItem,
  ListItemIcon,
  TextField,
  Typography,
} from "@material-ui/core";
import { ServiceReservation } from "../../../graphql/models";
import { useEffect, useMemo, useState } from "react";
import { DateTimePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { ServiceReservationStatus } from "../../../graphql/models";
import { DateTime } from "luxon";
import {
  Payment as PaymentIcon,
  CalendarToday as CalendarIcon,
  Notifications as NotificationIcon,
} from "@material-ui/icons";

export interface ServiceReservationPayAfterDataOnUpdate {}

export interface ServiceReservationPayAfterDataProps {
  reservation: ServiceReservation;
  onUpdate: (
    newAmount: number,
    newDate: Date | undefined,
    sendPush: boolean,
    pushMessage: string | undefined
  ) => void;
  consentStatusChange: (consent: boolean) => void;
}

export default function ServiceReservationPayAfterData(
  props: ServiceReservationPayAfterDataProps
) {
  const { reservation } = props;
  // states
  const [newAmount, setNewAmount] = useState(reservation.totalPrice);
  const [lastTimeForPayment, setLastTimeForPayment] = useState(
    reservation.lastTimeForPayment
      ? new Date(reservation.lastTimeForPayment)
      : undefined
  );
  const [sendPush, setSendPush] = useState(false);
  const [pushMessage, setPushMessage] = useState(reservation.pushMessage);
  // handlers
  const lastTimeForPaymentHandler = (v: MaterialUiPickersDate) => {
    if (v) setLastTimeForPayment(v);
    else setLastTimeForPayment(undefined);
  };
  // memos
  const disabled = useMemo(() => {
    const disabledStatuses = [
      ServiceReservationStatus.CONFIRMED,
      ServiceReservationStatus.REQUESTED_PAYMENT,
    ];
    return disabledStatuses.indexOf(reservation.status) >= 0;
  }, [reservation]);
  /**
   * push notification is allowed only if lastTimeForPayment is after the current time
   */
  const enablePushNotification = useMemo(() => {
    if (lastTimeForPayment === undefined) {
      return false;
    } else {
      const v = DateTime.now() < DateTime.fromJSDate(lastTimeForPayment!);
      return v;
    }
  }, [lastTimeForPayment]);
  // effects
  useEffect(() => {
    props.onUpdate(newAmount, lastTimeForPayment, sendPush, pushMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newAmount, lastTimeForPayment, sendPush, pushMessage]);
  useEffect(() => {
    console.log(`effect => ${disabled}`);
    props.consentStatusChange(!disabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);
  return (
    <>
      <ListItem>
        <ListItemIcon>
          <PaymentIcon />
        </ListItemIcon>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Typography variant="caption">Importo da addebitare</Typography>
          <TextField
            variant="outlined"
            disabled={disabled}
            type="number"
            value={newAmount}
            onChange={(evt) => setNewAmount(Number(evt.target.value))}
          ></TextField>
        </Box>
      </ListItem>
      <ListItem>
        <ListItemIcon>
          <CalendarIcon />
        </ListItemIcon>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Typography variant="caption">
            Data limite entro cui effettuare il pagamento
          </Typography>
          <DateTimePicker
            disabled={disabled}
            ampm={false}
            format="dd/MM/yyyy HH:mm"
            inputVariant="outlined"
            value={lastTimeForPayment}
            onChange={lastTimeForPaymentHandler}
          ></DateTimePicker>
        </Box>
      </ListItem>
      <ListItem>
        <ListItemIcon>
          <NotificationIcon />
        </ListItemIcon>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Typography variant="caption">
            Invio notifica PUSH al salvataggio
          </Typography>
          <Checkbox
            disabled={!enablePushNotification}
            value={sendPush}
            onChange={(e) => setSendPush(e.target.checked)}
          />
        </Box>
      </ListItem>
      <ListItem>
        <ListItemIcon>
          <NotificationIcon />
        </ListItemIcon>
        <TextField
          label="Testo specifico notifica PUSH"
          multiline={true}
          rows={3}
          variant="outlined"
          style={{ width: "100%" }}
          disabled={disabled}
          value={pushMessage}
          onChange={(e) => setPushMessage(e.target.value)}
        ></TextField>
      </ListItem>
    </>
  );
}
